import { ReporteVigilanciaTareasBarraComponent } from './reporte-vigilancia-tareas/reporte-vigilancia-barra.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { AsistenciaCursoComponent } from './asistencia-curso/asistencia-curso.component';
import { AsistenciaService } from './_services/asistencia.service';
import { GLMMaterialDesignModule } from '../../_components/material-design/material-design.module';
import { DynamicBarModule } from '../../_components/dynamic-bar/dynamic-bar.module';
import { AsistenciaRoutingModule } from './asistencia-routing.module';
import { AsistenciaComponent } from './asistencia.component';
import { NivelacionesModule } from '../nivelaciones/nivelaciones.module';
import { ListaAlumnosComponent } from './lista-alumnos/lista-alumnos.component';
import { CalendarWidgetModule } from '../../_components/calendar-widget/calendar-widget.module';
import { TiposAsistenciaResolver } from './_resolvers/tipos-asistencia-resolver.service';
import { AsistenciaCursoBarraComponent } from './asistencia-curso/asistencia-curso-barra.component';
import { AsistenciaReporteGeneralBarraComponent } from './reporte-general/reporte-general-barra.component';
import { AsistenciaReporteDirectorCursoComponent } from './reporte-director-curso/reporte-director-curso.component';
import { NavBarModule } from '../../_components/nav-bar/nav-bar.module';
import { FiltroMateriaNombrePipe } from './_pipes/filtro-materia-nombre.pipe';
import { AsistenciaReporteDireccionAcademicaComponent } from './reporte-direccion-academica/reporte-direccion-academica.component';
import { AsistenciaReporteCursoComponent } from './reporte-curso/reporte-curso.component';
import { AsistenciaReporteAlertasComponent } from './reporte-alertas/reporte-alertas.component';
import { GLMAppPipesModule } from '../_pipes/app-glm-pipes.module';
import { AsistenciaAlertasBarraComponent } from './reporte-alertas/reporte-alertas-barra.component';
import { AsistenciaDirectorCursoBarraComponent } from './reporte-director-curso/reporte-director-curso-barra.component';
import { AsistenciaReporteCursosBarraComponent } from './reporte-curso/reporte-curso-barra.component';
import { AsistenciaReporteDireccionAcademicaBarraComponent } from './reporte-direccion-academica/reporte-direccion-academica-barra.component';
import { CustomPipesModule } from '../../_pipes/custom-pipes.module';
import { GlmComentariosModule } from '../../_components/glm-comentarios/glm-comentarios.module';
import { ReporteTransporteComponent } from './reporte-transporte/reporte-transporte.component';
import { ReporteVigilanciaService } from './reporte-vigilancia-tareas/reporte-vigilancia.service';
import { AsistenciaCursoService } from './asistencia-curso/asistencia-curso.service';
import { ReporteGeneralService } from './reporte-general/reporte-general.service';
import { GraficasModule } from '../../_components/graficas/graficas.module';
import { WidgetNotificacionModule } from '../../_components/widget-notificacion/widget-notificacion.module';
import { ReporteDireccionCursoComponent } from './reporte-direccion-curso/reporte-direccion-curso.component';
import { AutorizacionPresencialComponent } from './autorizacion-presencial/autorizacion-presencial.component';
import { AutorizacionPresencialCrearComponent } from './autorizacion-presencial-crear/autorizacion-presencial-crear.component';
import { AutorizacionPresencialEliminarComponent } from './autorizacion-presencial-eliminar/autorizacion-presencial-eliminar.component';
import { ReporteDireccionCursoNotificarComponent } from './reporte-direccion-curso-notificar/reporte-direccion-curso-notificar.component';

import { AsistenciaGeneralComponent } from "../../asistencia-general/asistencia-general.component";
import { AsistenciaReporteGeneralComponent } from './reporte-general/reporte-general.component';
import { MatDatepickerModule } from "@angular/material/datepicker";
// import { MatMomentDateModule } from '@angular/material-moment-adapter';

import { ReporteVigilanciaTareasComponent } from './reporte-vigilancia-tareas/reporte-vigilancia-tareas.component';
// import { AsistenciaGeneralService } from './asistencia-general/asistencia-general.service';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { AsistenciaListaCursosService } from '../../asistencia-general/asistencia-lista-cursos/asistencia-lista-cursos.service';

@NgModule({
  providers: [
    AsistenciaService,
    ReporteVigilanciaService,
    TiposAsistenciaResolver,
    AsistenciaCursoService,
    ReporteGeneralService,
    AsistenciaListaCursosService,
  ],
  declarations: [
    AsistenciaComponent,
    AsistenciaCursoBarraComponent,
    AsistenciaReporteGeneralBarraComponent,
    AsistenciaCursoComponent,
    AsistenciaReporteDirectorCursoComponent,
    AsistenciaDirectorCursoBarraComponent,
    AsistenciaReporteDireccionAcademicaComponent,
    AsistenciaReporteDireccionAcademicaBarraComponent,
    AsistenciaReporteCursoComponent,
    AsistenciaReporteCursosBarraComponent,
    AsistenciaReporteAlertasComponent,
    AsistenciaAlertasBarraComponent,
    ListaAlumnosComponent,
    ReporteVigilanciaTareasComponent,
    ReporteVigilanciaTareasBarraComponent,
    ReporteTransporteComponent,
    FiltroMateriaNombrePipe,
    ReporteDireccionCursoComponent,
    AutorizacionPresencialComponent,
    AutorizacionPresencialCrearComponent,
    AutorizacionPresencialEliminarComponent,
    ReporteDireccionCursoNotificarComponent,
    AsistenciaReporteGeneralComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    GLMMaterialDesignModule,
    DynamicBarModule,
    NivelacionesModule,
    CalendarWidgetModule,
    NavBarModule,
    GLMAppPipesModule.forRoot(),
    CustomPipesModule,
    GlmComentariosModule,
    GraficasModule,
    WidgetNotificacionModule,

    MatDatepickerModule,
    MatMomentDateModule,

    MatSortModule,
    MatButtonModule,
    MatButtonToggleModule,

    AsistenciaRoutingModule,
  ],
})
export class AsistenciaModule {
}
